<template>
  <section class="container section">
    <h1 class="is-size-3 has-text-primary has-text-centered">ABOUT US</h1>
    <div class="columns">
      <div class="column">
        <p>
        Hello to all friends of the sea and all boat types. We are a group of professional
        skippers from different countries of Europe who have passed through all the stages
        of this field to get to the point of being able to be called professionals.
        </p>

        <p>
        We have worked hard in charter bases of large companies with high demands.
        </p>

        <p>
        We&#39;ve repaired all sorts of damages, so that boats could leave with safety for the
        next charters.
        </p>

        <p>
        We have rescued many people who were in danger, under harsh conditions, for
        various reasons.
        </p>

        <p>
        We spent endless hours at shipyards to learn exactly how each system works in
        order to achieve the best possible maintenance.
        </p>

        <p>
        We have recorded several thousands of miles on long journeys that lasted several
        days, even months, to transfer and deliver new and used boats to their owners.
        </p>

        <p>
        Somehow our love for the sea has brought us in this position to want to show people
        of any age (families, children, friends) its beauty.
        </p>

        <p>
        After many years of experience and engagement with customers and ship-owners, and
        under good and bad circumstances, we have decided to create a tool that will help
        us greatly in dealing with any kind of need.
        </p>

        <p>
        We are happy to present to you <b>skippersbook.com</b>
        </p>
      </div>
      <div class="column is-one-third">
        <img :src="`${$publicPath()}boat.jpg`" />
      </div>
    </div>
    <ContactFooter />
  </section>
</template>

<script>
import ContactFooter from '@/components/ContactFooter';


export default {
  components: {
    ContactFooter,
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 1rem;
}
</style>
